// extracted by mini-css-extract-plugin
module.exports = {"Onboarding":"Onboarding_Onboarding__FJptw","spinner":"Onboarding_spinner__LqDsb"};